"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
OrderService.$inject = ['api', 'extApi', '$q', 'ngDialog', 'confirmDialog', '$http', 'config'];
function OrderService(api, extApi, $q, ngDialog, confirmDialog, $http, config) {
    var service = {};
    var lastParams = null;
    service.fetch = function (p) {
        var params = {
            page: 1,
            size: 20,
            q: ''
        };
        if (p && p.page) {
            params.page = p.page;
        }
        if (p && p.size) {
            params.size = p.size;
        }
        if (p && p.q) {
            params.q = p.q;
        }
        //retrieve last params
        if (!p && lastParams) {
            _.extend(params, lastParams);
        }
        //save last params
        lastParams = params;
        return api.get('/b2b/order', params);
    };
    service.fetchExternal = function (p) {
        var params = {
            page: 1,
            per_page: 20,
            order_number: ''
        };
        if (p && p.page) {
            params.page = p.page;
        }
        if (p && p.per_page) {
            params.per_page = p.per_page;
        }
        if (p && p.q) {
            params.order_number = p.q;
        }
        //retrieve last params
        if (!p && lastParams) {
            _.extend(params, lastParams);
        }
        //save last params
        lastParams = params;
        return extApi.get('/orders', params);
    };
    service.getExternalOrder = function (order_id) {
        return extApi.get('/orders/' + order_id);
    };
    // service.cancelOrder = order_id => {
    // 	return api.update('/b2b/order/' + order_id, {status: 70});
    // };
    service.getOrderProducts = function (order_id) {
        return api.get('/b2b/order/' + order_id + '/products');
    };
    service.uploadDeliveryStickers = function (order_id, file, type) {
        var fd = new FormData();
        fd.append('file', file);
        fd.append('file_type', type);
        return $http.post(config.server.ext_url + '/orders/' + order_id + '/delivery-stickers', fd, {
            transformRequest: angular.identity,
            headers: {
                'Content-Type': undefined
            }
        }).then(function (response) {
            return response.data;
        });
    };
    service.cancelOrder = function (order_id) {
        var delay = $q.defer();
        confirmDialog.open('Da li ste sigurni da zelite da otkazete porudzbinu?</b>?')
            .then(function (confirm) {
            // api.update('/b2b/order/' + order_id, {status: 70})
            extApi.post('/orders/' + order_id + '/cancel', { reason: null })
                .then(function (response) {
                delay.resolve(response);
            }, function (e) {
                delay.reject(e.data.error);
            });
        }, function (close) {
            delay.reject();
        });
        return delay.promise;
    };
    service.confirmReservation = function (order_id) {
        var delay = $q.defer();
        confirmDialog.open('Da li ste sigurni da zelite da potvrdite rezervaciju?</b>?')
            .then(function (confirm) {
            extApi.post('/orders/' + order_id + '/reservation/confirm', {})
                .then(function (response) {
                delay.resolve(response);
            }, function (e) {
                delay.reject(e.data.error);
            });
        }, function (close) {
            delay.reject();
        });
        return delay.promise;
    };
    return service;
}
exports.OrderService = OrderService;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/order-list/services/orders.js
// module id = 417
// module chunks = 0